import * as actionTypes from "./actionTypes";

export const loadRestaurantMenuList = (
  id,
  orderType = null,
  all = null,
  data
) => {
  return {
    type: actionTypes.LOAD_RESTAURANT_MENU_LIST,
    id,
    orderType,
    all,
    data,
  };
};

export const loadRestaurantMenuListSuccess = (data) => {
  return {
    type: actionTypes.LOAD_RESTAURANT_MENU_LIST_SUCCESS,
    data,
  };
};

export const loadRestaurantMenuListFail = () => {
  return {
    type: actionTypes.LOAD_RESTAURANT_MENU_LIST_FAIL,
  };
};

/////////* New Menu Loading Method START *//////////
export const loadRestaurantMenuCategory = (id, orderType = "") => {
  return {
    type: actionTypes.LOAD_RESTAURANT_MENU_CATEGORY,
    id,
    orderType,
  };
};

export const loadRestaurantMenuCategorySuccess = (data) => {
  return {
    type: actionTypes.LOAD_RESTAURANT_MENU_CATEGORY_SUCCESS,
    data,
  };
};

export const loadRestaurantMenuCategoryFail = () => {
  return {
    type: actionTypes.LOAD_RESTAURANT_MENU_CATEGORY_FAIL,
  };
};

export const loadRestaurantMenuCategoryItems = (
  id,
  category,
  orderType = "",
  index
) => {
  return {
    type: actionTypes.LOAD_RESTAURANT_MENU_CATEGORY_ITEMS,
    id,
    category,
    orderType,
    index,
  };
};

export const loadRestaurantMenuCategoryItemsSuccess = (data) => {
  return {
    type: actionTypes.LOAD_RESTAURANT_MENU_CATEGORY_ITEMS_SUCCESS,
    data,
  };
};

export const loadRestaurantMenuCategoryItemsFail = () => {
  return {
    type: actionTypes.LOAD_RESTAURANT_MENU_CATEGORY_ITEMS_FAIL,
  };
};
/////////*  New Menu Loading Method END  *//////////

export const loadRestaurantMenuDetail = (id) => {
  return {
    type: actionTypes.LOAD_RESTAURANT_MENU_DETAIL,
    id,
  };
};

export const loadRestaurantMenuDetailSuccess = (data) => {
  return {
    type: actionTypes.LOAD_RESTAURANT_MENU_DETAIL_SUCCESS,
    data,
  };
};

export const loadRestaurantMenuDetailFail = () => {
  return {
    type: actionTypes.LOAD_RESTAURANT_MENU_DETAIL_SUCCESS,
  };
};
